/**
 * Development-only persistence for Deadhead Simon lane boundaries (localStorage).
 */

import {
  assertValidAutobahnLaneBoundaries,
  DEFAULT_AUTOBAHN_LANE_BOUNDARY_X_BOTTOM,
  formatAutobahnLaneBoundariesForLayoutFile,
} from '../exploreUnknownMinigames/minigames/autobahnLaneSimon/autobahnLaneSimonLayout';

const STORAGE_KEY = 'exploreUnknownAutobahnLaneBoundaries';

export const AUTOBAHN_LANE_BOUNDARY_COUNT = 5;

/**
 * @returns {number[] | null}
 */
export function loadDevAutobahnLaneBoundaries() {
  if (typeof window === 'undefined') {
    return null;
  }
  let raw;
  try {
    raw = window.localStorage.getItem(STORAGE_KEY);
  } catch (err) {
    throw new Error(`exploreUnknownAutobahnLaneDevStorage: localStorage read failed (${err?.message ?? err})`);
  }
  if (raw == null || raw === '') {
    return null;
  }
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (err) {
    throw new Error(`exploreUnknownAutobahnLaneDevStorage: stored JSON is invalid (${err?.message ?? err})`);
  }
  if (!Array.isArray(parsed) || parsed.length !== AUTOBAHN_LANE_BOUNDARY_COUNT) {
    throw new Error('exploreUnknownAutobahnLaneDevStorage: expected 5 boundary values');
  }
  const boundaries = parsed.map((x) => Math.round(Number(x)));
  assertValidAutobahnLaneBoundaries(boundaries);
  return boundaries;
}

/**
 * @param {number[]} boundaries
 */
export function saveDevAutobahnLaneBoundaries(boundaries) {
  if (typeof window === 'undefined') {
    throw new Error('exploreUnknownAutobahnLaneDevStorage: window is required');
  }
  assertValidAutobahnLaneBoundaries(boundaries);
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(boundaries));
  } catch (err) {
    throw new Error(`exploreUnknownAutobahnLaneDevStorage: localStorage write failed (${err?.message ?? err})`);
  }
}

export function clearDevAutobahnLaneBoundaries() {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    throw new Error(`exploreUnknownAutobahnLaneDevStorage: localStorage remove failed (${err?.message ?? err})`);
  }
}

/**
 * @returns {number[]}
 */
export function getDefaultAutobahnLaneBoundaries() {
  return [...DEFAULT_AUTOBAHN_LANE_BOUNDARY_X_BOTTOM];
}

export { formatAutobahnLaneBoundariesForLayoutFile };
